import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { EditorNavbar } from "components/modules/Navigation/EditorNavbar/EditorNavbar";
import dynamic from "next/dynamic";
import type { MemeTemplate } from "types/meme";
import { Layout } from "./Layout/Layout";
import { MemeEditorProvider } from "./MemeEditorProvider";

const LeftBar = dynamic<{}>(() => import("./LeftBar/LeftBar").then((mod) => mod.LeftBar));
const Preview = dynamic<{}>(() => import("./Preview/Preview").then((mod) => mod.Preview));
const ControlBar = dynamic<{}>(() => import("./ControlBar/ControlBar").then((mod) => mod.ControlBar));
const BottomMenu = dynamic<{}>(() => import("./BottomMenu/BottomMenu").then((mod) => mod.BottomMenu));
const MobileAction = dynamic<{}>(() => import("./Actions/MobileAction/MobileAction").then((mod) => mod.MobileAction));

export interface MemeGeneratorProps {
    initialMemes: Array<MemeTemplate>;
    defaultMeme: MemeTemplate;
    isEditPage?: boolean;
}

export const MemeGenerator = ({ initialMemes, defaultMeme, isEditPage }: MemeGeneratorProps) => {
    return (
        <ReduxProvider>
            <MemeEditorProvider initialMemes={initialMemes} defaultMeme={defaultMeme} isEditPage={isEditPage}>
                <Layout
                    action={{ desktop: null }}
                    bottomMenu={<BottomMenu />}
                    controlBar={<ControlBar />}
                    leftBar={<LeftBar />}
                    navbar={<EditorNavbar actionButton={<MobileAction />} url="/meme-generator" />}
                    preview={<Preview />}
                    config={{
                        hideTopAd: true,
                        hideBottomAd: true,
                    }}
                />
            </MemeEditorProvider>
        </ReduxProvider>
    );
};
